// Paylaşılan FormField — label + input/select/textarea wrap + opsiyonel hint/error
// Kullanım:
//   <FormField label="Ad" required>
//     <input type="text" value={...} onChange={...} />
//   </FormField>
//
//   <FormField label="Şehir" hint="Önce ülke seçin">
//     <select>...</select>
//   </FormField>
//
//   <FormField label="E-posta" error="Geçersiz format">
//     <input type="email" />
//   </FormField>
import React from 'react';
import { useTranslation } from 'react-i18next';
import { fieldLabel } from '../../i18n/fieldMap';

export default function FormField({
  label,
  required = false,
  hint,
  error,
  fullWidth = false,
  className = '',
  children,
}) {
  const { i18n } = useTranslation();
  // String label'ları otomatik EN'e çevir (TR → EN map'ten). JSX label'lar aynen kalır.
  const renderLabel = typeof label === 'string' ? fieldLabel(label, i18n.language) : label;
  // İçindeki ilk input/select/textarea'ya .ui-input class'ını otomatik enjekte et
  const enhanced = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return child;
    const tag = (typeof child.type === 'string') ? child.type : null;
    if (['input', 'select', 'textarea'].includes(tag)) {
      const existing = child.props.className || '';
      const cls = ('ui-input ' + (error ? 'ui-input-error ' : '') + existing).trim();
      return React.cloneElement(child, { className: cls });
    }
    return child;
  });
  return (
    <div className={'ui-field ' + (fullWidth ? 'full ' : '') + className}>
      {label && (
        <label className="ui-field-label">
          {renderLabel}{required && <span className="ui-field-required">*</span>}
        </label>
      )}
      {enhanced}
      {hint && !error && <div className="ui-field-hint">{hint}</div>}
      {error && <div className="ui-field-error">{error}</div>}
    </div>
  );
}
